import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause, faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';
import { Box, CircularProgress } from '@mui/material';
import Logo from '../../../../assets/images/neophyte_logo.png';
import './video.css';

const VideoComponent = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);
  const [embedUrl, setEmbedUrl] = useState('');
  const videoContainerRef = useRef(null);
  const dispatch = useDispatch();

  // Get the selected camera data from Redux
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);

  useEffect(() => {
    if (selectedCamera?.videoUrl) {
      // Convert Google Drive sharing URL to embed URL
      const fileId = selectedCamera.videoUrl.match(/[-\w]{25,}/);
      if (fileId) {
        setEmbedUrl(`https://drive.google.com/file/d/${fileId[0]}/preview`);
      } else {
        setEmbedUrl(selectedCamera.videoUrl);
      }
    }
  }, [selectedCamera]);

  const togglePlayPause = () => {
    if (!videoPlaying) {
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: true });
    } else {
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
    }
  };

  const toggleFullScreen = () => {
    if (!isFullScreen) {
      if (videoContainerRef.current.requestFullscreen) {
        videoContainerRef.current.requestFullscreen();
      } else if (videoContainerRef.current.mozRequestFullScreen) {
        videoContainerRef.current.mozRequestFullScreen();
      } else if (videoContainerRef.current.webkitRequestFullscreen) {
        videoContainerRef.current.webkitRequestFullscreen();
      } else if (videoContainerRef.current.msRequestFullscreen) {
        videoContainerRef.current.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsFullScreen(!isFullScreen);
  };

  return (
    <div className="video-component" ref={videoContainerRef}>
      {isLoading ? (
        <div style={{ height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {videoPlaying && selectedCamera && embedUrl ? (
            <iframe
              className="border border-black w-full"
              id="videoElement"
              src={embedUrl}
              style={isFullScreen ? { height: '85vh' } : { height: '60vh' }}
              allowFullScreen
              allow="autoplay"
              onError={(e) => {
                console.error('Error loading video:', e);
                dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
              }}
            />
          ) : (
            <div style={isFullScreen ? { height: '85vh' } : { height: '60vh' }} className="flex flex-col justify-center items-center">
              <img src={Logo} alt="Neophyte Logo" style={{ maxWidth: '200px' }} />
              <p className="mt-4 text-gray-600">Select a camera to start viewing</p>
            </div>
          )}
        </>
      )}

      <div className="controls">
        <div className="top-controls"></div>

        <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'center' }}>
          <button onClick={togglePlayPause} className="play-pause-btn invisible">
            <FontAwesomeIcon icon={videoPlaying ? faPause : faPlay} />
          </button>

          <div className="bottom-controls">
            <input type="text" placeholder="Search" className="search-bar" />
            <button onClick={toggleFullScreen} className="fullscreen-btn invisible">
              {!isFullScreen ? <FontAwesomeIcon icon={faExpand} /> : <FontAwesomeIcon icon={faCompress} />}
            </button>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default VideoComponent;
